<template>
  <mdc-dialog class="behavior-modal"
              v-model="isOpen"
              :title="'behavior.edit_typical_client_behavior' | trans"
              :accept="'behavior.buttons.save' | trans"
              :accept-disabled="isMensurationForbidden"
              @cancel="cancel"
              @close="close"
              @validate="validate"
              :class="{'fullscreen-dialog' : isMobile}">

    <div v-if="!isMobile" class="close-cross" @click="cancel()">
      <mdc-icon icon="close"></mdc-icon>
    </div>

    <div v-else>
      <mdc-toolbar slot="toolbar"
                   class="navbar-expand-lg navbar-custom  navbar-dark bg-primary mb-4 mb-md-4">
        <div class="container">
          <!--  toolbar markup here -->
          <mdc-toolbar-row>
            <mdc-toolbar-section shrink-to-fit>
                            <span @click="cancel()">
                                <mdc-icon icon="close"></mdc-icon>
                            </span>
              <h3 class="title">{{'behavior.edit_typical_behavior' |
                trans}}</h3>
            </mdc-toolbar-section>
            <mdc-toolbar-section align-end v-if="!isMensurationForbidden">
                             <span @click.prevent="validate()">
                                <mdc-icon icon="done"></mdc-icon>
                            </span>
            </mdc-toolbar-section>
          </mdc-toolbar-row>
        </div>
      </mdc-toolbar>
    </div>


    <div class="form-group row">
      <div class="col-md-12">
        <b class="behavior-modal__subtitle">{{'behavior.ancedent' | trans}}</b>
      </div>

      <div class="col-md-12">
        <div v-for="(ancedent, index) in typicalAncedent" :key="index"
             class="radio-btn">
          {{ancedent.text}}
          <div v-if="!isMensurationForbidden" class="close-cross" @click="removeAncedent(index, ancedent)">
            <mdc-icon icon="close"></mdc-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group row align-items-center">
      <div class="col-8 col-md-9">
        <mdc-textfield v-model="newTypicalAncedent.text"
                       name="newTypicalAncedent"
                       :class="{'is-invalid': errors.has('isNotUniqueAncedent') || errors.has('isEmptyErrorAncedent') || errors.has('isMaxLengthAncedent') || errors.has('newTypicalAncedent')}"
                       :disabled="isMensurationForbidden"
                       type="text"
                       v-validate="'min:1|max:200'"
                       data-vv-validate-on="none"
                       :data-vv-as="'behavior.enter_the_new_ancedent' | trans"
                       :label="'behavior.enter_the_new_ancedent' | trans"
                       v-on:keyup.enter="addAncedent"/>
        <span class="invalid-feedback"
              v-if="errors.has('newTypicalAncedent')">
                                    <strong>{{ errors.first('newTypicalAncedent') }}</strong>
                                </span>
      </div>

      <div class="col-4 col-md-3" v-if="!isMensurationForbidden">
        <button type="button"
                class="col-12 mdc-button mdc-button--raised button-primary"
                @click="addAncedent()">
          <span>{{'appeals.buttons.addAppeal' | trans}}</span>
        </button>
      </div>

      <div class="col-md-12">
        <span class="invalid-feedback-label"
              v-if="errors.has('isNotUniqueAncedent') || errors.has('isEmptyErrorAncedent') || errors.has('isMaxLengthAncedent')">
          <strong>{{ errors.first('isNotUniqueAncedent') || errors.first('isEmptyErrorAncedent') || errors.first('isMaxLengthAncedent') }}</strong>
        </span>
      </div>

    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <b class="behavior-modal__subtitle mt30">{{'behavior.behavior' |
          trans}}</b>
      </div>

      <div class="col-md-12">
        <div v-for="(behavior, index) in typicalBehavior" :key="index"
             class="radio-btn">
          {{behavior.text}}
          <div v-if="!isMensurationForbidden" class="close-cross" @click="removeBehavior(index, behavior)">
            <mdc-icon icon="close"></mdc-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group row align-items-center">
      <div class="col-8 col-md-9">
        <mdc-textfield v-model="newTypicalBehavior.text"
                       name="newTypicalBehavior"
                       :class="{'is-invalid': errors.has('isNotUniqueBehavior') || errors.has('isEmptyErrorBehavior') || errors.has('isMaxLengthBehavior') || errors.has('newTypicalBehavior')}"
                       :disabled="isMensurationForbidden"
                       type="text"
                       v-validate="'min:1|max:200'"
                       data-vv-validate-on="none"
                       :data-vv-as="'behavior.enter_the_new_behavior' | trans"
                       :label="'behavior.enter_the_new_behavior' | trans"
                       v-on:keyup.enter="addBehavior"/>
        <span class="invalid-feedback"
              v-if="errors.has('newTypicalBehavior')">
                                    <strong>{{ errors.first('newTypicalBehavior') }}</strong>
                                </span>
      </div>
      <div class="col-4 col-md-3" v-if="!isMensurationForbidden">
        <button type="button"
                class="col-12 mdc-button mdc-button--raised button-primary"
                @click="addBehavior()">
          <span>{{'appeals.buttons.addAppeal' | trans}}</span>
        </button>
      </div>

      <div class="col-md-12">
        <span class="invalid-feedback-label"
              v-if="errors.has('isNotUniqueBehavior') || errors.has('isEmptyErrorBehavior') || errors.has('isMaxLengthBehavior')">
          <strong>{{ errors.first('isNotUniqueBehavior') || errors.first('isEmptyErrorBehavior') || errors.first('isMaxLengthBehavior') }}</strong>
        </span>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <b class="behavior-modal__subtitle mt30">{{'behavior.ub_environment' |
          trans}}</b>
      </div>

      <div class="col-md-12">
        <div v-for="(aftermath, index) in typicalEffects" :key="index"
             class="radio-btn">
          {{aftermath.text}}
          <div v-if="!isMensurationForbidden" class="close-cross" @click="removeEffect(index, aftermath)">
            <mdc-icon icon="close"></mdc-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group row align-items-center">
    <div class="col-8 col-md-9">
      <mdc-textfield v-model="newTypicalEffect.text"
                     name="newTypicalEffect"
                     :class="{'is-invalid': errors.has('isNotUniqueEffect') || errors.has('isEmptyErrorEffect') || errors.has('isMaxLengthEffect') || errors.has('newTypicalEffect')}"
                     type="text"
                     :disabled="isMensurationForbidden"
                     v-validate="'min:1|max:200'"
                     data-vv-validate-on="none"
                     :data-vv-as="'behavior.enter_the_new_aftermath' | trans"
                     :label="'behavior.enter_the_new_aftermath' | trans"
                     v-on:keyup.enter="addEffect"/>
      <span class="invalid-feedback"
            v-if="errors.has('newTypicalEffect')">
                                    <strong>{{ errors.first('newTypicalEffect') }}</strong>
                                </span>
    </div>
    <div class="col-4 col-md-3" v-if="!isMensurationForbidden">
      <button type="button"
              class="col-12 mdc-button mdc-button--raised button-primary"
              @click="addEffect()">
        <span>{{'appeals.buttons.addAppeal' | trans}}</span>
      </button>
    </div>
  
    <div class="col-md-12">
        <span class="invalid-feedback-label"
              v-if="errors.has('isNotUniqueEffect') || errors.has('isEmptyErrorEffect') || errors.has('isMaxLengthEffect')">
          <strong>{{ errors.first('isNotUniqueEffect') || errors.first('isEmptyErrorEffect') || errors.first('isMaxLengthEffect') }}</strong>
        </span>
    </div>

  </div>
    
    <div class="form-group row" v-if="!isClient">
      <div class="col-md-12">
        <b class="behavior-modal__subtitle mt30">{{'behavior.ub_behavior' | trans}}</b>
      </div>
 
      <div class="col-md-12">
        <div v-for="(consequence, index) in typicalConsequenceInBehavior" :key="index"
             class="radio-btn">
          {{consequence.text}}
          <div v-if="!isMensurationForbidden" class="close-cross" @click="removeConsequenceInBehavior(index, consequence)">
            <mdc-icon icon="close"></mdc-icon>
          </div>
        </div>
      </div>
    </div>
  
    <div class="form-group row align-items-center" v-if="!isClient">
      <div class="col-8 col-md-9">
        <mdc-textfield v-model="newTypicalConsequenceInBehavior.text"
                       name="newTypicalConsequenceInBehavior"
                       :class="{'is-invalid': errors.has('isNotUniqueConsequenceInBehavior') || errors.has('isEmptyErrorConsequenceInBehavior') || errors.has('isMaxLengthConsequenceInBehavior') || errors.has('newTypicalConsequenceInBehavior')}"
                       type="text"
                       :disabled="isMensurationForbidden"
                       v-validate="'min:1|max:200'"
                       data-vv-validate-on="none"
                       :data-vv-as="'behavior.enter_the_new_aftermath' | trans"
                       :label="'behavior.enter_the_new_aftermath' | trans"
                       v-on:keyup.enter="addConsequenceInBehavior"/>
        <span class="invalid-feedback"
              v-if="errors.has('newTypicalConsequenceInBehavior')">
                                    <strong>{{ errors.first('newTypicalConsequenceInBehavior') }}</strong>
                                </span>
      </div>
      <div class="col-4 col-md-3" v-if="!isMensurationForbidden">
        <button type="button"
                class="col-12 mdc-button mdc-button--raised button-primary"
                @click="addConsequenceInBehavior()">
          <span>{{'appeals.buttons.addAppeal' | trans}}</span>
        </button>
      </div>
    
      <div class="col-md-12">
        <span class="invalid-feedback-label"
              v-if="errors.has('isNotUniqueConsequenceInBehavior') || errors.has('isEmptyErrorConsequenceInBehavior') || errors.has('isMaxLengthEffect')">
          <strong>{{ errors.first('isNotUniqueConsequenceInBehavior') || errors.first('isEmptyErrorConsequenceInBehavior') || errors.first('isMaxLengthConsequenceInBehavior') }}</strong>
        </span>
      </div>
  
    </div>

    <footer class="col-12 px-0 mdc-dialog__footer mdc-dialog__footer--visible"
            v-if="isMobile">
      <button type="button"
              :disabled="isMensurationForbidden"
              class="col-12 mdc-button mdc-button--raised button-primary"
              @click="validate()">
        <span>{{'behavior.buttons.save' | trans}}</span>
      </button>
    </footer>
  </mdc-dialog>
</template>

<script>
  import apiUndesirableBehavior from '../api/undesirableBehavior';
  import cloneDeep from 'lodash/cloneDeep';
  import {mapGetters, mapActions, mapState} from 'vuex';
  import trim from 'lodash/trim';
  import Constants from '../Constants';
  import lang from '../../../lang/translator';
  import forEach from 'lodash/forEach';

  export default {
    name: 'editTypicalBehaviorsModal',
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    data() {
      return {
        typicalAncedent: [],
        removedTypicalAncedent: [],
        typicalBehavior: [],
        typicalConsequenceInBehavior: [],
        removedTypicalConsequenceInBehavior: [],
        removedTypicalBehavior: [],
        typicalEffects: [],
        removedTypicalEffect: [],
        newTypicalAncedent: {
          text: '',
          id: null,
        },
        newTypicalBehavior: {
          text: '',
          id: null,
        },
        newTypicalEffect: {
          text: '',
          id: null,
        },
        newTypicalConsequenceInBehavior: {
          text: '',
          id: null
        },
      };
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        },
      },
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      ...mapGetters('auth', [
        'isMensurationForbidden',
        'isClient',
      ]),
      ...mapState('behavior', [
        'typicalBehaviors',
      ]),
    },
    created(){
      if (this.clientId) {
        this.setTypesBehaviors(this.clientId);
      }
    },
    methods: {
      ...mapActions('behavior', [
        'setTypesBehaviors',
      ]),

      async validate() {
        let result = await this.$validator.validateAll();

        if (result) {
          try {
            let response = await apiUndesirableBehavior.saveTypes(this.clientId,
                this.typicalAncedent,
                this.typicalBehavior,
                this.typicalEffects,
                this.typicalConsequenceInBehavior);
            this.setTypesBehaviors(this.clientId);
            this.close();
          } catch (error) {
            console.dir(error);
          }
        }
      },

      async addAncedent() {
        let ancedent = cloneDeep(this.newTypicalAncedent);

        if (this.typicalAncedent.length < Constants.MAX_LENGTH) {
          let result = await this.$validator.validateAll();

          if (result && ancedent.text !== '') {
            let uniqueCounter = 0;

            for (let i = 0; i < Object.keys(this.typicalAncedent).length; i++) {
              if (trim(this.typicalAncedent[i].text.toLowerCase()) ===
                  trim(ancedent.text.toLowerCase())) {
                uniqueCounter++;
              }
            }

            for (let i = 0; i <
            Object.keys(this.removedTypicalAncedent).length; i++) {
              if (trim(this.removedTypicalAncedent[i].text.toLowerCase()) ===
                  trim(ancedent.text.toLowerCase())) {
                ancedent = this.removedTypicalAncedent[i];
              }
            }

            if (uniqueCounter === 0) {
              ancedent.createdAt = Math.round((new Date().getTime())/1000);
              this.typicalAncedent.push(cloneDeep(ancedent));
              this.newTypicalAncedent.text = '';
            }
            else {
              this.errors.add({
                field: 'isNotUniqueAncedent',
                msg: lang.get('behavior.unique_ancedent'),
              });
            }
          }
          else if (ancedent.text === '') {
            this.errors.add({
              field: 'isEmptyErrorAncedent',
              msg: lang.get('behavior.need_choice_ancedent'),
            });
          }
        }
        else {
          console.info("isMaxLengthAncedent")
          this.errors.add({
            field: 'isMaxLengthAncedent',
            msg: lang.get('behavior.maxlength_ancedent'),
          });
        }
      },

      async addBehavior() {
        let behavior = cloneDeep(this.newTypicalBehavior);

        if (this.typicalBehavior.length < Constants.MAX_LENGTH) {
          let result = await this.$validator.validateAll();

          if (result && behavior.text !== '') {
            let uniqueCounter = 0;

            for (let i = 0; i < Object.keys(this.typicalBehavior).length; i++) {
              if (trim(this.typicalBehavior[i].text.toLowerCase()) ===
                  trim(behavior.text.toLowerCase())) {
                uniqueCounter++;
              }
            }

            for (let i = 0; i <
            Object.keys(this.removedTypicalBehavior).length; i++) {
              if (trim(this.removedTypicalBehavior[i].text.toLowerCase()) ===
                  trim(behavior.text.toLowerCase())) {
                behavior = this.removedTypicalBehavior[i];
              }
            }

            if (uniqueCounter === 0) {
              behavior.createdAt = Math.round((new Date().getTime())/1000);
              this.typicalBehavior.push(cloneDeep(behavior));
              this.newTypicalBehavior.text = '';
            }
            else {
              this.errors.add({
                field: 'isNotUniqueBehavior',
                msg: lang.get('behavior.unique_behaviors'),
              });
            }
          }
          else if (behavior.text === '') {
            this.errors.add({
              field: 'isEmptyErrorBehavior',
              msg: lang.get('behavior.need_choice_behavior'),
            });
          }
        }
        else {
          this.errors.add({
            field: 'isMaxLengthBehavior',
            msg: lang.get('behavior.maxlength_behaviors'),
          });
        }
      },


      async addConsequenceInBehavior() {
        let consequenceInBehavior = cloneDeep(this.newTypicalConsequenceInBehavior);

        if (this.typicalConsequenceInBehavior.length < Constants.MAX_LENGTH) {
          let result = await this.$validator.validateAll();

          if (result && behavior.text !== '') {
            let uniqueCounter = 0;

            for (let i = 0; i < Object.keys(this.typicalConsequenceInBehavior).length; i++) {
              if (trim(this.typicalConsequenceInBehavior[i].text.toLowerCase()) ===
                trim(consequenceInBehavior.text.toLowerCase())) {
                uniqueCounter++;
              }
            }

            for (let i = 0; i <
            Object.keys(this.removedTypicalConsequenceInBehavior).length; i++) {
              if (trim(this.removedTypicalConsequenceInBehavior[i].text.toLowerCase()) ===
                trim(consequenceInBehavior.text.toLowerCase())) {
                consequenceInBehavior = this.removedTypicalConsequenceInBehavior[i];
              }
            }

            if (uniqueCounter === 0) {
              consequenceInBehavior.createdAt = Math.round((new Date().getTime())/1000);
              this.typicalConsequenceInBehavior.push(cloneDeep(consequenceInBehavior));
              this.newTypicalConsequenceInBehavior.text = '';
            }
            else {
              this.errors.add({
                field: 'isNotUniqueBehavior',
                msg: lang.get('behavior.unique_behaviors'),
              });
            }
          }
          else if (consequenceInBehavior.text === '') {
            this.errors.add({
              field: 'isEmptyErrorBehavior',
              msg: lang.get('behavior.need_choice_behavior'),
            });
          }
        }
        else {
          this.errors.add({
            field: 'isMaxLengthBehavior',
            msg: lang.get('behavior.maxlength_behaviors'),
          });
        }
      },

      async addEffect() {
        let effect = cloneDeep(this.newTypicalEffect);

        if (this.typicalEffects.length < Constants.MAX_LENGTH) {
          let result = await this.$validator.validateAll();

          if (result && effect.text !== '') {
            let uniqueCounter = 0;

            for (let i = 0; i < Object.keys(this.typicalEffects).length; i++) {
              if (trim(this.typicalEffects[i].text.toLowerCase()) ===
                  trim(effect.text.toLowerCase())) {
                uniqueCounter++;
              }
            }

            for (let i = 0; i <
            Object.keys(this.removedTypicalEffect).length; i++) {
              if (trim(this.removedTypicalEffect[i].text.toLowerCase()) ===
                  trim(effect.text.toLowerCase())) {
                effect = this.removedTypicalEffect[i];
              }
            }

            if (uniqueCounter === 0) {
              effect.createdAt = Math.round((new Date().getTime())/1000);
              this.typicalEffects.push(cloneDeep(effect));
              this.newTypicalEffect.text = '';
            }
            else {
              this.errors.add({
                field: 'isNotUniqueEffect',
                msg: lang.get('behavior.unique_aftermath'),
              });
            }
          }
          else if (effect.text === '') {
            this.errors.add({
              field: 'isEmptyErrorEffect',
              msg: lang.get('behavior.need_choice_aftermath'),
            });
          }
        }
        else {
          this.errors.add({
            field: 'isMaxLengthEffect',
            msg: lang.get('behavior.maxlength_aftermath'),
          });
        }
      },

      async addConsequenceInBehavior() {
        let consequenceInBehavior = cloneDeep(this.newTypicalConsequenceInBehavior);

        if (this.typicalConsequenceInBehavior.length < Constants.MAX_LENGTH) {
          let result = await this.$validator.validateAll();

          if (result && consequenceInBehavior.text !== '') {
            let uniqueCounter = 0;

            for (let i = 0; i < Object.keys(this.typicalConsequenceInBehavior).length; i++) {
              if (trim(this.typicalConsequenceInBehavior[i].text.toLowerCase()) ===
                trim(consequenceInBehavior.text.toLowerCase())) {
                uniqueCounter++;
              }
            }

            for (let i = 0; i <
            Object.keys(this.removedTypicalConsequenceInBehavior).length; i++) {
              if (trim(this.removedTypicalConsequenceInBehavior[i].text.toLowerCase()) ===
                trim(consequenceInBehavior.text.toLowerCase())) {
                consequenceInBehavior = this.removedTypicalConsequenceInBehavior[i];
              }
            }

            if (uniqueCounter === 0) {
              consequenceInBehavior.createdAt = Math.round((new Date().getTime())/1000);
              this.typicalConsequenceInBehavior.push(cloneDeep(consequenceInBehavior));
              this.newTypicalConsequenceInBehavior.text = '';
            }
            else {
              this.errors.add({
                field: 'isNotUniqueConsequenceInBehavior',
                msg: lang.get('behavior.unique_aftermath'),
              });
            }
          }
          else if (consequenceInBehavior.text === '') {
            this.errors.add({
              field: 'isEmptyErrorConsequenceInBehavior',
              msg: lang.get('behavior.need_choice_aftermath'),
            });
          }
        }
        else {
          this.errors.add({
            field: 'isMaxLengthConsequenceInBehavior',
            msg: lang.get('behavior.maxlength_aftermath'),
          });
        }
      },
      
      removeAncedent(index, item) {
        this.removedTypicalAncedent.push(item);
        this.typicalAncedent.splice(index, 1);
      },

      removeBehavior(index, item) {
        this.removedTypicalBehavior.push(item);
        this.typicalBehavior.splice(index, 1);
      },

      removeEffect(index, item) {
        this.removedTypicalEffect.push(item);
        this.typicalEffects.splice(index, 1);
      },

      removeConsequenceInBehavior(index, item) {
        this.removedTypicalConsequenceInBehavior.push(item);
        this.typicalConsequenceInBehavior.splice(index, 1);
      },

      reset() {
        this.newTypicalAncedent.text = '';
        this.newTypicalBehavior.text = '';
        this.newTypicalEffect.text = '';
        this.newTypicalConsequenceInBehavior.text = '';
        this.removedTypicalAncedent = [];
        this.removedTypicalBehavior = [];
        this.removedTypicalEffect = [];
        this.removedTypicalConsequenceInBehavior = [];
        this.errors.clear();
      },

      close() {
        this.reset();
        this.$emit('close');
      },

      cancel() {
        this.reset();
        this.$emit('cancel');
      },
    },
    watch: {
      typicalBehaviors() {
        this.typicalAncedent = cloneDeep(this.typicalBehaviors.antecedentTypes);
        this.typicalBehavior = cloneDeep(this.typicalBehaviors.behaviorTypes);
        this.typicalEffects = cloneDeep(this.typicalBehaviors.effectsTypes);
        this.typicalConsequenceInBehavior = cloneDeep(this.typicalBehaviors.consequenceInBehaviorTypes);

        forEach(this.typicalAncedent, (item) => {
          if (item.createdAt){
            let convertDate = Math.round((new Date(item.createdAt.date).getTime())/1000);
            item.createdAt = convertDate;
          }
        });

        forEach(this.typicalBehavior, (item) => {
          if (item.createdAt){
            let convertDate = Math.round((new Date(item.createdAt.date).getTime())/1000);
            item.createdAt = convertDate;
          }
        });

        forEach(this.typicalEffects, (item) => {
          if (item.createdAt){
            let convertDate = Math.round((new Date(item.createdAt.date).getTime())/1000);
            item.createdAt = convertDate;
          }
        });

        forEach(this.typicalConsequenceInBehavior, (item) => {
          if (item.createdAt){
            let convertDate = Math.round((new Date(item.createdAt.date).getTime())/1000);
            item.createdAt = convertDate;
          }
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/undesirableBehavior/components/editTypicalBehaviorsModal.vue